document.querySelectorAll('[data-variant-select]').forEach(select => {
  select.addEventListener('change', () => select.form.requestSubmit());
});
const modelField = document.querySelector('[data-contact-model]');
if (modelField) {
  const model = new URLSearchParams(window.location.search).get('model');
  if (model) modelField.value = model.slice(0, 200);
}
const quantityField = document.querySelector('[data-contact-quantity]');
if (quantityField) {
  const quantity = new URLSearchParams(window.location.search).get('quantity');
  if (/^[1-9]\d{0,2}$/.test(quantity || '')) quantityField.value = quantity;
}
document.querySelectorAll('.mobile-menu, .nav-dropdown').forEach(menu => {
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  menu.addEventListener('toggle', () => {
    if (menu.open) document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach(other => { if (other !== menu) other.open = false; });
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});

document.querySelectorAll('[data-request-catalog]').forEach(catalog => {
  const search = catalog.querySelector('[data-catalog-search]');
  const category = catalog.querySelector('[data-catalog-category]');
  const cards = [...catalog.querySelectorAll('[data-catalog-card]')];
  const count = catalog.querySelector('[data-catalog-count]');
  search.value = new URLSearchParams(window.location.search).get('q') || '';
  const filter = () => {
    const query = search.value.trim().toLocaleLowerCase();
    let shown = 0;
    cards.forEach(card => {
      card.hidden = !(card.dataset.search.includes(query) && (!category.value || card.dataset.category === category.value));
      if (!card.hidden) shown += 1;
    });
    count.textContent = `${shown} ${count.dataset.countLabel}`;
    catalog.querySelector('[data-catalog-empty]').hidden = shown !== 0;
  };
  search.addEventListener('input', filter);
  category.addEventListener('change', filter);
  filter();
});

const directEmail = document.querySelector('[data-direct-email]');
if (directEmail && modelField?.value) {
  directEmail.href = `mailto:cindy@cooperriver.ai?subject=${encodeURIComponent(`Equipment quote request: ${modelField.value}`)}&body=${encodeURIComponent(`Model: ${modelField.value}\nQuantity: ${quantityField?.value || '1'}\nDelivery ZIP:\nReceiving requirements:\nQuestions:\n`)}`;
}
document.querySelector('[data-email-details]')?.addEventListener('click', event => {
  const form = event.currentTarget.form;
  const lines = [];
  for (const [name, value] of new FormData(form)) {
    const field = name.match(/^contact\[([^\]]+)\]$/);
    if (field && String(value).trim() && field[1] !== 'request source') lines.push(`${field[1]}: ${String(value).trim()}`);
  }
  const subject = `Equipment quote request${modelField?.value ? `: ${modelField.value}` : ''}`;
  window.location.href = `mailto:cindy@cooperriver.ai?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n').slice(0,2200))}`;
});
